module.exports = __webpack_public_path__ + "img/IR.2cd89129.svg";